<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Capacità lt" v-model="element.capacity" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Tipo"
        v-model="element.kind"
        :options="['Aperto', 'Chiuso', 'Sanitario', 'Riscaldamento']"
        multiple
      />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Pressione di precarica (bar)" v-model="element.pression" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>